import AdminLayout from "../../components/admin/AdminLayout";
import AnalyticsDashboard from "./AnalyticsDashboard";
import DashboardOverview from "./DashboardOverview";

export default function AdminDashboard() {
  return (
    <AdminLayout>

      <DashboardOverview />

    </AdminLayout>
  );
}

export function AssessmentPage() {
  return (
    <AdminLayout title="Assessment Analytics">

      <AnalyticsDashboard />

    </AdminLayout>
  );
}
